(function($, undefined) {
	
	'use strict';
	var currPage;
	var modifyPasswordBtn;
	var savePersonalInfosForm;
	var savePersonalInfosBtn;
	var savePaymentInfosForm;
	var savePaymentInfosBtn;
	var editPaymentInfosBtn;
	var deletePaymentInfosBtn;
    var saveBillingInfosForm;
    var saveBillingInfosBtn;
    var editBillingInfosBtn;
    var deleteBillingInfosBtn;

	var enablePasswordModification = function() {
		var t = $(this);
		var parent = t.closest('.box-theme-content');

		parent.find('.old-password').removeClass('disabled').removeClass('focused').find('input').val('');
		parent.find('.password').removeClass('disabled').removeClass('focused').find('input').val('');
		t.slideUp(300, function() {
			$(this).parent().slideUp(300, function() {
				$(this).remove();
			});
		});
	};

	var savePersonalInfos = function() {
		var btn = $(this);
		var form = btn.closest('.js-form');

		btn.addClass('disabled');
		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			var url = '/action/updatePerson';
			url += '?firstName=' + encodeURIComponent($('input[name="firstName"]', form).val());
			url += '&lastName=' + encodeURIComponent($('input[name="lastName"]', form).val());
			url += '&email=' + encodeURIComponent($('input[name="email"]', form).val());
			url += '&phone=' + encodeURIComponent($('input[name="phone"]', form).val());
			url += '&address=' + encodeURIComponent($('input[name="address"]', form).val()); 
			url += '&postalCode=' + encodeURIComponent($('input[name="postalCode"]', form).val());
			url += '&province=' + $('.province-select', form).val();
			url += '&city=' + encodeURIComponent($('input[name="city"]', form).val());
			url += '&country=' + $('select[name="country"]', form).val();
			url += '&field2=' + encodeURIComponent($('input[name="field2"]', form).val());
			url += '&field3=' + encodeURIComponent($('input[name="field3"]', form).val());
			url += '&field4=' + encodeURIComponent($('input[name="field4"]', form).val());
			url += '&field5=' + encodeURIComponent($('input[name="field5"]', form).val());
			url += '&field19=' + encodeURIComponent($('select[name="field19"]', form).val());
            if ($('input[name="field2"]', form).val() !== $('input[name="field2"]', form).attr("data-misc") || $('input[name="field3"]', form).val() !== $('input[name="field3"]', form).attr("data-misc")) {
                url += '&field18=false';
            }
			if (!$('.old-password', form).hasClass('disabled')) {
				url += '&currentPassword=' + encodeURIComponent($('input[name="currentPassword"]', form).val());
				url += '&password=' + encodeURIComponent($('input[name="password"]', form).val());
			}
			url += '&ajax=true';

			var obj = ajax(url,function (response) {
				btn.removeClass('disabled');
				
				if (response.indexOf('error') != -1) {
					form.find('.js-form-error-message.email-in-use').slideDown(300, function() {
						setTimeout(function() {
							form.find('.js-form-error-message.email-in-use').slideUp(300);
						}, 5000);
					});
				} else if (response.indexOf('wrong.password') != -1) {
					form.find('.js-form-error-message.old-password').slideDown(300, function() {
						setTimeout(function() {
							form.find('.js-form-error-message.old-password').slideUp(300);
						}, 5000);
					});
				} else if (response.indexOf('success') != -1) {
					removeTabWarning(form);
					form.find('.account-params-infos-missing-warning').slideUp(300, function() {
						$(this).remove();
					});
					form.find('.js-form-success-message').slideDown(300, function() {
						setTimeout(function() {
							form.find('.js-form-success-message').slideUp(300);
						}, 5000);
					});
				}
			},true);
		} else {
			btn.removeClass('disabled');
		}
	};

	var savePaymentInfos = function() {
		var btn = $(this);
		var form = btn.closest('.js-form');

		btn.addClass('disabled');
		formValidator.validateForm(form);
		confirmBankAccountNumber(form);

		if (!form.hasClass('has-error') && !form.hasClass('has-bank-account-confirm-error')) {
			var bankCountry = $('select[name="field6"]', form);
			var bankName = $('input[name="field7"]', form).val();
			var bankAccountType = $('select[name="field8"]', form);
			var bankAccountNumber = $('input[name="bank-account-numbers-1"]').val() + $('input[name="bank-account-numbers-2"]').val() + $('input[name="bank-account-numbers-3"]').val();

			var url = '/action/updatePerson';
			url += '?field6=' + bankCountry.val();
			url += '&field7=' + encodeURIComponent(bankName);
			url += '&field8=' + bankAccountType.val();
			url += '&field9=' + bankAccountNumber;
			url += '&ajax=true';

			var obj = ajax(url,function (response) {
				btn.removeClass('disabled');
				
				if (response.indexOf('success') !== -1) {
					removeTabWarning(form);
					form.find('.js-form-success-message').slideDown(300, function() {
						setTimeout(function() {
							form.find('.js-form-success-message').slideUp(300);
						}, 5000);
					});
					form.find('.form-inputs-ctn').slideUp(300, function() {
						fillAndDisplayBankAccountInfos(form, bankCountry, bankName, bankAccountType, bankAccountNumber);
					});
				}
			},true);
		} else {
			btn.removeClass('disabled');
		}
	};

	var confirmBankAccountNumber = function(form) {
		var numberPartThree = $('input[name="bank-account-numbers-3"]', form);
		var fullNumber = $('input[name="field9"]', form);
		var bankNumberErrorMsg = form.find('.bank-account-number.error-msg');
		
		if (numberPartThree.val() !== '' && fullNumber.val() !== '') {		
			if (numberPartThree.val() !== fullNumber.val()) {
				form.addClass('has-bank-account-confirm-error');
				numberPartThree.addClass('error').removeClass('success');
				fullNumber.addClass('error').removeClass('success');
				bankNumberErrorMsg.slideDown(300);
			} else {
				form.removeClass('has-bank-account-confirm-error');
				numberPartThree.removeClass('error').addClass('success');
				fullNumber.removeClass('error').addClass('success');
				bankNumberErrorMsg.slideUp(300);
			}
		}
	};

	var fillAndDisplayBankAccountInfos = function(form, bankCountry, bankName, bankAccountType, bankAccountNumber) {
		var displayBankInfosCtn = form.closest('.box-theme-content').find('.account-params-saved-payment-infos-ctn');

		$('.account-params-payment-infos-country', displayBankInfosCtn).html(bankCountry.find('option:selected').text());
		$('.account-params-payment-infos-bank', displayBankInfosCtn).html(bankName);
		$('.account-params-payment-infos-account-type', displayBankInfosCtn).html(bankAccountType.find('option:selected').text());
		$('.account-params-payment-infos-bank-account-1', displayBankInfosCtn).html(bankAccountNumber.substring(0,5));
		$('.account-params-payment-infos-bank-account-2', displayBankInfosCtn).html(bankAccountNumber.substring(5,8));
		$('.account-params-payment-infos-bank-account-3', displayBankInfosCtn).html(bankAccountNumber.substring(8));

		displayBankInfosCtn.slideDown(300);
	};

	var editInfos = function() {
		var t = $(this);

		t.closest('.saved-account-infos-display-ctn').slideUp(300, function() {
			t.closest('.box-theme-content').find('.js-form').slideDown(300);
			t.closest('.box-theme-content').find('.form-inputs-ctn').slideDown(300);
		});
	};

	var deletePaymentInfos = function() {
		var t = $(this);
		var form = t.closest('.box-theme-content').find('.js-form');
		var tab = $('.tabs-bar-and-content-ctn.account-params-ctn').find('.account-tab-item[data-tab=' + form.closest('.tabs-content-inner-ctn').attr('data-tab') + ']');

		// reset form
		form.find('input:text, input:password, input:file, select, textarea').val('').removeClass('success');
		form.find('.input-ctn').removeClass('focused');

		// add tab warning
		tab.addClass('orange').find('.required-fields-completed-icon-ctn').fadeOut(300, function() {
			tab.find('.attention-required-icon-ctn').fadeIn(300);
		});

		// updatePerson (empty fields)
		var url = '/action/updatePerson?field6=&field7=&field8=&field9=&ajax=true';
		var obj = ajax(url, function(){            
            // hide infos, show form
            t.closest('.saved-account-infos-display-ctn').slideUp(300, function() {			
                t.closest('.box-theme-content').find('.form-inputs-ctn').slideDown(300);
            });
        },true);

	};
	
	var removeTabWarning = function(ctn) {
		var tabNumber = ctn.closest('.tabs-content-inner-ctn').attr('data-tab');
		var tab = $('.tabs-bar-and-content-ctn.account-params-ctn').find('.account-tab-item[data-tab=' + tabNumber + ']');

		tab.removeClass('orange');
		tab.find('.attention-required-icon-ctn').fadeOut(300, function() {
			tab.find('.required-fields-completed-icon-ctn').fadeIn(300);
		});
	};

	var checkCreditCardDate = function(form) {
		var ctn = form.find('.month-year-ctn');
		var chosenMonthSelect = ctn.find('select[name=expMM]');
		var chosenYearSelect = ctn.find('select[name=expYY]');
		var chosenMonthVal = parseInt(chosenMonthSelect.val());
		var chosenYearVal = parseInt(chosenYearSelect.val());

		if (isNaN(chosenMonthVal) || isNaN(chosenYearVal)) {
			return;
		}

		var currMonth = parseInt(ctn.attr('data-curr-month'));
		var currYear = parseInt(ctn.attr('data-curr-year').substring(2));

		if (chosenYearVal > currYear) {
			form.removeClass('has-cc-expired-error');
			form.find('.js-form-error-message.credit-card-expired').slideUp();
			chosenMonthSelect.removeClass('error');
			chosenYearSelect.removeClass('error');
			return;
		} else if (chosenYearVal === currYear) {
			if (chosenMonthVal > currMonth) {
				form.removeClass('has-cc-expired-error');
				form.find('.js-form-error-message.credit-card-expired').slideUp();
				chosenMonthSelect.removeClass('error');
				chosenYearSelect.removeClass('error');
				return;
			} else {
				form.addClass('has-cc-expired-error');
				form.find('.js-form-error-message.credit-card-expired').slideDown();
				chosenMonthSelect.addClass('error');
				chosenYearSelect.addClass('error');
			}
		}
	};

    var saveBillingInfos = function() {
		var btn = $(this);
		var form = btn.closest('.js-form');

		formValidator.validateForm(form);
		checkCreditCardDate(form);

		if (!form.hasClass('has-error') && !form.hasClass('has-cc-expired-error')) {
			btn.addClass('disabled');
			var ccType = $('select[name="CCType"]', form);
			var name = $('input[name="name"]', form);
			var ccNumber = $('input[name="ccNumber"]', form);
			var expMM = $('select[name="expMM"]', form);
			var expYY = $('select[name="expYY"]', form);
			var street = $('input[name="street"]', form);
			var city = $('input[name="city"]', form);
			var country = $('select[name="country"]', form);
			var province = $('input[name="province"]', form);
			var pc = $('input[name="postalCode"]', form);
			var cvv = $('input[name="cvv"]', form);

			var url = '/action/epSaveCCInfos';
			url += '?CCType=' + ccType.val();
			url += '&name=' + encodeURIComponent(name.val());
			url += '&ccNumber=' + ccNumber.val();
			url += '&expMM=' + expMM.val();
			url += '&expYY=' + expYY.val();
			url += '&street=' + encodeURIComponent(street.val());
			url += '&city=' + encodeURIComponent(city.val());
			url += '&country=' + encodeURIComponent(country.val());
			url += '&province=' + encodeURIComponent(province.val());
			url += '&postalCode=' + encodeURIComponent(pc.val());
			url += '&ajax=true';

			var obj = ajax(url,function (response) {
				if (response.indexOf('success') !== -1) {
					removeTabWarning(form);
					form.find('.js-form-success-message').slideDown(300, function() {
						setTimeout(function() {
							form.find('.js-form-success-message').slideUp(300);
						}, 5000);
					});
					form.find('.form-inputs-ctn').slideUp(300, function() {
						fillAndDisplayBillingInfos(form, ccType.val(), name.val(), ccNumber.val().substring(ccNumber.val().length - 4), expMM.val() + "/" + expYY.val());
                        
                        ccNumber.val("");
                        ccNumber.parent().removeClass("focused");
                        cvv.val("");
                        cvv.parent().removeClass("focused");
					});
				}
			},true);
			btn.removeClass('disabled');
		}
	};
    
    var fillAndDisplayBillingInfos = function(form, ccType, name, ccNumber, exp) {
		var displayBillingInfosCtn = form.closest('.box-theme-content').find('.account-params-saved-billing-infos-ctn');

		$('.saved-billing-info-name', displayBillingInfosCtn).html(name);
		$('.saved-billing-info-ccnumber', displayBillingInfosCtn).html("**** **** **** "+ccNumber);
		$('.saved-billing-info-exp', displayBillingInfosCtn).html(exp);
		
        $('.credit-card-logo-ctn', displayBillingInfosCtn).removeClass("visa").removeClass("master").removeClass("amex").removeClass("discover");
        $('.credit-card-logo-ctn', displayBillingInfosCtn).addClass(ccType);
        $('.credit-card-logo-ctn', displayBillingInfosCtn).html($('.all-credit-card-logos-ctn .'+ccType, form).html());
		
		displayBillingInfosCtn.slideDown(300);
	};
    
    var deleteBillingInfos = function(){
		var t = $(this);
		var form = t.closest('.box-theme-content').find('.js-form');
		var tab = $('.tabs-bar-and-content-ctn.account-params-ctn').find('.account-tab-item[data-tab=' + form.closest('.tabs-content-inner-ctn').attr('data-tab') + ']');

        var url = '/action/epSaveCCInfos';
        url += '?remove=true';
        url += '&ajax=true';
        
        var obj = ajax(url,function (response) {
            if (response.indexOf('success') !== -1) {
                // reset form
                form.find('input:text, input:password, input:file, select, textarea').val('').removeClass('success');
                form.find('.input-ctn').removeClass('focused');
                
                // add tab warning
                tab.addClass('orange').find('.required-fields-completed-icon-ctn').fadeOut(300, function() {
                    tab.find('.attention-required-icon-ctn').fadeIn(300);
                });
                // hide infos, show form
                t.closest('.saved-account-infos-display-ctn').slideUp(300, function() {			
                    t.closest('.box-theme-content').find('.form-inputs-ctn').slideDown(300);
                });
            }
        },true);
    };
    

	var init = function (page) {
		currPage = $(page);

		modifyPasswordBtn = $('.account-params-modify-password-btn');
		savePersonalInfosForm = $('.account-params-personal-infos-form');
		savePersonalInfosBtn = $('.save-personal-infos-btn', savePersonalInfosForm);
		savePaymentInfosForm = $('.account-params-payment-infos-form');
		savePaymentInfosBtn = $('.save-payment-infos-btn', savePaymentInfosForm);
		editPaymentInfosBtn = $('.edit-payment-infos-btn');
		deletePaymentInfosBtn = $('.delete-payment-infos-btn');
		saveBillingInfosForm = $('.account-params-billing-infos-form');
		saveBillingInfosBtn = $('.save-billing-infos-btn', saveBillingInfosForm);
		editBillingInfosBtn = $('.edit-billing-infos-btn');
		deleteBillingInfosBtn = $('.delete-billing-infos-btn');
        
		modifyPasswordBtn.click(enablePasswordModification);
		savePersonalInfosBtn.click(savePersonalInfos);
		savePaymentInfosBtn.click(savePaymentInfos);
		editPaymentInfosBtn.click(editInfos);
		deletePaymentInfosBtn.click(deletePaymentInfos);
		saveBillingInfosBtn.click(saveBillingInfos);
		editBillingInfosBtn.click(editInfos);
		deleteBillingInfosBtn.click(deleteBillingInfos);
        
		// Country / Province select
		initChangeStates([$('select[name="country"]'), $('select[name="billing-country"]')]);
		$('select[name="country"]').change(function() {
			initChangeStates($(this));
		});

		$('select[name="billing-country"]').change(function() {
			initChangeStates($(this));
		});
	};
	
	$(window).on("load",function(){
		init();
	});
})(jQuery);